import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "src/store";
import { selectCurrentWorkspaceId } from "src/store/app";
import { useStreamingLog } from "src/ui/utils/useStream";

import { useWorkspaceFeature } from "@dashboard/workspaces/api/helpers";
import { License } from "@devices/types";
import { SecondaryButton } from "@shared/CustomButton";
import { LogStreamModal, StreamStatus } from "@shared/LogStreamModal";
import { Tooltip } from "@shared/Tooltip";

import { getReasonMessage, onStartStreaming } from "./LogButton.utils";

export const LogButton = (license: License) => {
    const [open, setOpen] = React.useState(false);
    const [status, onStatusChange] = React.useState<StreamStatus>("initializing");

    const { t } = useTranslation(["sidepanels", "modals"]);

    const workspaceId = useSelector(selectCurrentWorkspaceId);
    const limit = useWorkspaceFeature("StreamSessionLimit");
    const isHidden = !license.device?.isOnline || !license.device?.id || limit === 0;

    const { containerRef, scrollContainerRef, onClearStream, onRunStream } = useStreamingLog({
        onStartStreaming: () => onStartStreaming(license.device?.id, workspaceId),
        onStatusChange,
    });

    const onOpen = () => {
        setOpen(true);
        onRunStream();
    };

    const onClose = () => {
        setOpen(false);
        onClearStream();
    };

    return (
        <React.Fragment>
            <Tooltip title={getReasonMessage(limit, license)}>
                <SecondaryButton onClick={onOpen} disabled={isHidden}>
                    <i className="fa-solid fa-align-left" />
                </SecondaryButton>
            </Tooltip>
            <LogStreamModal
                open={open}
                status={status}
                onClose={onClose}
                title={t("modals:logStreamer.deviceLogsTitle", { id: license.device?.id })}
                contentRef={containerRef}
                containerRef={scrollContainerRef}
            />
        </React.Fragment>
    );
};
